/**
 * Allow changing position for sticky web components.
 * Require adding top, bottom, left and right properies on component.
 * List of supported components: uiaas-search-accessibility-toggle
 */
export const moveStickyWebComponent = (elementName: string, direction: string, value: number) => {
    const element = document.querySelector(elementName);

    if (element) {
      element.setAttribute(direction, value.toString());
    }
};

/**
 * Allow changing position for inner elements in parent web component
 * Require adding top, bottom, left and right properies on component.
 * List of supported components: svs-scroll-to-top-button
 */
export const moveStickyInnerComponent = (parentElement: string, innerElement: string, direction: string, value: number) => {
    const element = document.querySelector(parentElement)?.shadowRoot?.querySelector(innerElement);

    if (element) {
      element.setAttribute(direction, value.toString());
    }
};

/**
 * Set correct directions for components.
 * List of supported components: uiaas-search-accessibility-toggle, svs-scroll-to-top-button
 */
export const setFlexComponentPosition = (
  context: any, //eslint-disable-line
  innerElementSelector: string,
  isShadowRoot = true
) => {
    const directions = ['top', 'bottom', 'left', 'right'];
    const innerElement = isShadowRoot ? context.element.shadowRoot.querySelector(innerElementSelector) : context.element.querySelector(innerElementSelector);

    if (innerElement) {
      directions.map(direction => innerElement.style[direction] = (context?.[direction] ?? false) ? context[direction] + 'px' : '');
    }
};
